/**
 * Garante que o estado de hidratação do vue-query nunca seja `undefined`.
 *
 * Como `ssr: false`, o `dehydrate()` do módulo nunca roda no servidor, então
 * `useState("vue-query-nuxt")` chega vazio no cliente. Dependendo da versão
 * resolvida de `@tanstack/query-core` (pode variar entre ambientes/lockfiles),
 * `hydrate()` não valida esse estado antes de acessar `.mutations`/`.queries`,
 * causando o erro "Cannot read properties of undefined (reading 'mutations')".
 *
 * Este plugin roda com `enforce: "pre"`, ou seja, antes do plugin do módulo
 * `@hebilicious/vue-query-nuxt`, e preenche o estado com um valor seguro.
 */
export default defineNuxtPlugin({
  name: "vue-query-hydration-fix",
  enforce: "pre",
  setup() {
    const vueQueryState = useState("vue-query-nuxt");

    if (!vueQueryState.value) {
      vueQueryState.value = { queries: [], mutations: [] };
    }
  },
});
